import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    GetCorrectionRun: { providesTags: ['CorrectionRun'] },
    GetCorrectionRuns: { providesTags: ['CorrectionRun'] },
    CreateCorrectionRun: { invalidatesTags: ['CorrectionRun'] },
    PlanCorrectionRun: { invalidatesTags: ['CorrectionRun'] },
    ApproveCorrectionRun: { invalidatesTags: ['CorrectionRun'] },
    CancelCorrectionRun: { invalidatesTags: ['CorrectionRun'] },
  },
});
